import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';

export const fetchInventory = createAsyncThunk(
  'inventory/fetchInventory',
  async ({ page = 1, limit = 8 } = {}, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const clubId = state.club?.club?.id;

      if (!clubId) return rejectWithValue('Club ID not found');

      const response = await api.get(
        `/club-equipment/club/${clubId}?page=${page}&limit=${limit}`
      );
      const { data, pagination } = response.data;

      return { data, pagination };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Ошибка запроса');
    }
  }
);

const initialState = {
  inventory: {
    data: [],
    pagination: {},
  },
  editObj: {},
  isLoadingInventory: false,
  errorInventory: null,
};

const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    addInventory(state, action) {
      state.inventory.data.push(action.payload);
      if (state.inventory.pagination?.total != null) {
        state.inventory.pagination.total += 1;
      }
    },
    deleteInventory(state, action) {
      const itemId = action.payload;
      state.inventory.data = state.inventory.data.filter(
        (item) => item.id !== itemId
      );
      if (state.inventory.pagination?.total != null) {
        state.inventory.pagination.total -= 1;
      }
    },
    updateInventory(state, action) {
      const updatedItem = action.payload;
      const index = state.inventory.data.findIndex(
        (item) => item.id === updatedItem.id
      );
      if (index !== -1) {
        state.inventory.data[index] = {
          ...state.inventory.data[index],
          ...updatedItem,
        };
      }
    },
    setEditObj(state, action) {
      state.editObj = { ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventory.pending, (state) => {
        state.isLoadingInventory = true;
        state.errorInventory = null;
      })
      .addCase(fetchInventory.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.inventory.data = data;
        state.inventory.pagination = pagination;
        state.isLoadingInventory = false;
      })
      .addCase(fetchInventory.rejected, (state, action) => {
        state.isLoadingInventory = false;
        state.errorInventory =
          action.payload || 'Не удалось загрузить инвентарь';
      });
  },
});

export const { addInventory, deleteInventory, updateInventory, setEditObj } =
  inventorySlice.actions;

export default inventorySlice.reducer;
